<template>
    <ul class="tab_writing">
        <template v-for="(item, i) in links">
            <li
                    :key="i"
                    :class="$route.query?.tabIndex == item.tabIndex ? 'on' : null"
            >
                <a href="javascript:void(0);"
                   @click="changePage(item)">
                    {{ item.name }}
                </a>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        data() {
            return {
                tabIndex: 0,
                links: [
                    {
                        name: "공정도 작성 목록",
                        url: "/account/mypage/createdList",
                        tabIndex: 0,
                    },
                ]
            }
        },
        async mounted() {
            // 로그인 여부 확인.
            let userData = await this.$wApi.user.mypage.me();
            if (userData == null || userData?.error) {
                this.$router.push("/account/login");
            }
        },
        methods: {
            changePage(item){
                this.$router.push({path:`${item.url}`, query:{tabIndex:item.tabIndex}});
            }
        }
    };
</script>